import {DateTime} from "luxon";

function getDiffInMonths(start: DateTime, end: DateTime): number {
    return end.diff(start, 'months').months;
}
export default {
    getDiffInMonths
};
